// Display mode constants
export const DISPLAY_MODES = {
  GRID: 'grid',
  CAROUSEL: 'carousel',
  COMPACT_GRID: 'compact-grid',
  AUTO: 'auto'
};

// Responsive breakpoints for auto mode
export const RESPONSIVE_BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1200
};

// Default responsive display modes
export const DEFAULT_RESPONSIVE_MODES = {
  mobile: DISPLAY_MODES.CAROUSEL,
  tablet: DISPLAY_MODES.GRID,
  desktop: DISPLAY_MODES.GRID
};

// Utility functions
export const getDisplayMode = (mode, responsiveBreakpoints = DEFAULT_RESPONSIVE_MODES) => {
  if (mode !== DISPLAY_MODES.AUTO) {
    return mode;
  }

  // Auto mode - determine based on screen size
  const width = window.innerWidth;

  if (width < RESPONSIVE_BREAKPOINTS.mobile) {
    return responsiveBreakpoints.mobile;
  } else if (width < RESPONSIVE_BREAKPOINTS.tablet) {
    return responsiveBreakpoints.tablet;
  } else {
    return responsiveBreakpoints.desktop;
  }
};

export const isCarouselMode = (mode) => {
  return mode === DISPLAY_MODES.CAROUSEL;
};

export const isGridMode = (mode) => {
  return mode === DISPLAY_MODES.GRID || mode === DISPLAY_MODES.COMPACT_GRID;
};